'use client';

import cx from 'classnames';
import { useEffect, useState } from 'react';

import { Spinner } from '@flipster/react/design-system/spinner';
import { css } from '@flipster/styled-system/css';

import { KatexStyles } from './KatexStyles';
import styles from './markdown.module.scss';
import { MdRenderOptions, convertMarkdownToHtml } from './utils';

interface Props {
  content: string;
  className?: string;
  options?: MdRenderOptions;
}

export const MDRenderer = ({ content, className, options }: Props) => {
  const [output, setOutput] = useState('');

  useEffect(() => {
    if (!content) return;
    convertMarkdownToHtml(content, options)
      .then((html) => {
        if (!html) return;
        setOutput(html);
      })
      .catch();
  }, [output, content, options]);

  return (
    <>
      <KatexStyles />
      <aside className={cx(styles.wrapper, className)}>
        {!output && (
          <div className={css({ display: 'flex', justifyContent: 'center', w: '100%' })}>
            <Spinner size={40} color='white' />
          </div>
        )}
        <div dangerouslySetInnerHTML={{ __html: output }} />
      </aside>
    </>
  );
};
